import { render, staticRenderFns } from "./awaken.vue?vue&type=template&id=420f5099&scoped=true"
import script from "./awaken.vue?vue&type=script&lang=js"
export * from "./awaken.vue?vue&type=script&lang=js"
import style0 from "./awaken.vue?vue&type=style&index=0&id=420f5099&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420f5099",
  null
  
)

export default component.exports